import script from "./ShapeStack.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShapeStack.vue?vue&type=script&lang=ts&setup=true"

import "./ShapeStack.vue?vue&type=style&index=0&id=4e61c9e8&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e61c9e8"]])

export default __exports__